import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CatModule } from '@app/shared/ui/cat/cat.module';
import { NewModalModule } from 'outshared-lib';
import { DownloadingModalComponent } from './downloading-modal.component';

/**
 * @deprecated use version from libs
 */
@NgModule({
    imports: [
        CommonModule,
        NewModalModule,
        CatModule,
    ],
    exports: [
        DownloadingModalComponent,
    ],
    declarations: [
        DownloadingModalComponent,
    ],
})
export class DownloadingModalModule { }
